"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const react_i18next_1 = require("react-i18next");
const package_1 = require("../package");
const ConversionContainer = ({ onClick, points, tokens, classes, t, loading, disabled, balance }) => {
    const pointsText = points > 1
        ? t('store.point_plural', { amount: points.toPointsFormat() })
        : t('store.point', { amount: points.toPointsFormat() });
    const tokensText = tokens > 1
        ? t('store.token_plural', { amount: tokens.toPointsFormat() })
        : t('store.token', { amount: tokens.toPointsFormat() });
    const showConversionButton = balance > 0 && balance >= points;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.content }, { children: [(0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ smDown: true }, { children: (0, jsx_runtime_1.jsx)("img", { "aria-label": 'Players Club Logo', src: package_1.assets.internalAssets.playersClubLogoWhite, alt: 'Players Club Logo', className: classes.logoPL }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.conversionContent }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'h6', color: 'secondary', align: 'center', component: 'h2' }, { children: t('store.convertTitle') })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.conversionType }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.conversionTypeBox }, { children: [(0, jsx_runtime_1.jsx)("img", { "aria-label": 'Players Club Logo Small', src: package_1.assets.internalAssets.playersClubLogoWhite, alt: 'Players Club Logo Small', className: classes.logoSmall }), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'h6', color: 'textPrimary', align: 'center', component: 'p' }, { children: t('store.points') }))] })), (0, jsx_runtime_1.jsx)("img", { "aria-label": 'Convert arrow', src: package_1.assets.internalAssets.convertArrow, alt: 'Convert arrow', className: classes.conversionArrow }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.conversionTypeBox }, { children: [(0, jsx_runtime_1.jsx)("img", { "aria-label": 'Lucky Lounge Logo Small', src: package_1.assets.internalAssets.luckyLoungeLogoWhite, alt: 'Lucky Lounge Logo Small', className: classes.logoSmall }), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'h6', color: 'textPrimary', component: 'p' }, { children: t('store.token_plural') }))] }))] })), loading ? null : showConversionButton ? ((0, jsx_runtime_1.jsxs)(core_1.Button, Object.assign({ disabled: disabled, variant: 'contained', size: 'large', color: 'primary', onClick: onClick }, { children: [`${pointsText} = ${tokensText}`, (0, jsx_runtime_1.jsx)(package_1.ArcadeCurrency, { color: 'secondary' })] }))) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.notPoints }, { children: (0, jsx_runtime_1.jsx)(package_1.ArcadeNotification, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "body1", color: 'textPrimary' }, { children: t('arcade.notEnoughPointsToRedeemForTokens') })) }) })))] })), (0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ smDown: true }, { children: (0, jsx_runtime_1.jsx)("img", { "aria-label": 'Lucky Lounge Logo', src: package_1.assets.internalAssets.luckyLoungeLogoWhite, alt: 'Lucky Lounge Logo', className: classes.logoLL }) }))] })));
};
const styles = (theme) => (0, core_1.createStyles)({
    content: {
        backgroundColor: theme.palette.primary.dark.getWithAlpha(0.7),
        borderRadius: 10,
        height: 312,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    logoPL: {
        height: 160,
        opacity: 0.1,
        [theme.breakpoints.down('md')]: {
            height: 120
        }
    },
    logoLL: {
        height: 140,
        opacity: 0.1,
        [theme.breakpoints.down('md')]: {
            height: 100
        }
    },
    logoSmall: {
        height: 60,
        marginBottom: theme.spacing()
    },
    conversionContent: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: theme.spacing(12.5),
        marginRight: theme.spacing(12.5),
        [theme.breakpoints.down('md')]: {
            marginLeft: theme.spacing(3),
            marginRight: theme.spacing(3)
        }
    },
    conversionArrow: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing()
    },
    conversionType: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3)
    },
    conversionTypeBox: {
        display: 'flex',
        flexDirection: 'column',
        width: 100,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: 20,
        padding: '16px 8px',
        boxSizing: 'content-box'
    },
    notPoints: {
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        flexDirection: 'column'
    }
});
exports.default = (0, core_1.withStyles)(styles)((0, react_i18next_1.withTranslation)()(ConversionContainer));
//# sourceMappingURL=ConversionContainer.js.map